import React, {MouseEventHandler, useEffect, useRef, useState} from 'react'
import Swal from 'sweetalert2'
import {useIntl} from 'react-intl'
import clsx from 'clsx'
import styled from 'styled-components'

import {publishPersonArticle, removePersonArticle} from '@api/requests'
import {KTIcon, toAbsoluteUrl} from '@_metronic/helpers'

import useShareTreeLink from '@hooks/useShareTreeLink'
import useIsPremium from '@app/hooks/useIsPremium'

import {useArticleStore} from '@store/articles'
import {useEditArticleDrawerStore} from '@_metronic/partials/layout/editarticle-drawer/EditArticleDrawer'

import ShareLink, {ShareIcon} from '@components/atoms/ShareLink'

import {Article, PersonModel} from '@api/models'
import withReactContent from 'sweetalert2-react-content'
import {useAuth} from '@modules/auth'
import {useLang} from '@_metronic/i18n/Metronici18n'
const MySwal = withReactContent(Swal)

type SimArticleMenuProps = {
  first: boolean
  last: boolean
  readonly: boolean
  allowSharing?: boolean
  publish?: boolean
  personId: PersonModel['id']
  article: Article
  upArticle: MouseEventHandler<HTMLSpanElement>
  downArticle: MouseEventHandler<HTMLSpanElement>
  moveToFirst: MouseEventHandler<HTMLSpanElement>
  moveToLast: MouseEventHandler<HTMLSpanElement>
  articlesLength: number
}
const SimArticleMenu = ({
  first,
  last,
  readonly,
  publish,
  allowSharing,
  personId,
  article,
  upArticle,
  downArticle,
  moveToFirst,
  moveToLast,
  articlesLength,
}: SimArticleMenuProps) => {
  const intl = useIntl()
  const {currentUser} = useAuth()
  const language = useLang()
  const is_premium = useIsPremium()

  const {removeArticle,publishArticle} = useArticleStore()
  const {open: showEditArticle} = useEditArticleDrawerStore()

  const shareTreeLink = useShareTreeLink({
    personId,
    articleId: article._id,
  })

  const handleEditPress = () => {
    console.log('## handleEditPress')
    showEditArticle({article, personId})
  }

  const handleDeletePress = () => {
    const articleId = article._id

    Swal.fire({
      heightAuto: false,
      title: intl.formatMessage({id: 'A.YOU.SURE'}),
      // text: `Вы хотите удалить персонажа - ${person.first_name} ${person.last_name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#50cd89',
      cancelButtonText: intl.formatMessage({id: 'CANCEL'}),
      confirmButtonText: intl.formatMessage({id: 'DELETE'}),
    }).then((result) => {
      if (result.isConfirmed) {
        removeArticle(articleId)
        removePersonArticle(personId, articleId)
      }
    })

    return
  }
  const handlePublishArticle = (publish:boolean) =>{
    const articleId = article._id

    Swal.fire({
      heightAuto: false,
      title: intl.formatMessage({id: 'A.YOU.SURE'}),
      // text: `Вы хотите удалить персонажа - ${person.first_name} ${person.last_name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#50cd89',
      cancelButtonColor: '#d33',
      cancelButtonText: intl.formatMessage({id: 'CANCEL'}),
      confirmButtonText: intl.formatMessage({id: publish ? 'ARTICLE.SET.PUBLISH' : 'ARTICLE.SET.UNPUBLISH'}),
    }).then((result) => {
      if (result.isConfirmed) {
        publishArticle(articleId,publish)
        publishPersonArticle(articleId,publish,language,currentUser?.id || 0)
        MySwal.fire({
          title: intl.formatMessage({id: !publish ? 'ARTICLE.SUCCESS.UNPUBLISH' : 'ARTICLE.SUCCESS.PUBLISH'}),
          text: '',
          icon: 'success',
          showConfirmButton: false,
          timer: 1500,
          heightAuto: false,
        })
       /* removeArticle(articleId)
        removePersonArticle(personId, articleId)*/
      }
    })

    return
  }

  const [menuVisible, setMenuVisible] = useState(false)
  const menuRef = useRef(null)

  useEffect(() => {
    const handleClick = (e) => {
      // if (menuRef.current && !menuRef.current.contains(e.target)) {
      setMenuVisible(false)
      // }
    }

    document.addEventListener('mouseup', handleClick)
    return () => {
      document.removeEventListener('mouseup', handleClick)
    }
  }, [])

  return (
    <div className='position-relative'>
      <button
        type='button'
        className='btn btn-sm btn-icon btn-secondary ms-2'
        onClick={() => setMenuVisible(true)}
      >
        <KTIcon iconName='menu' className='fs-2' />
      </button>

      <MenuDropdown
        ref={menuRef}
        className={clsx(
          'menu menu-sub menu-sub-dropdown position-absolute',
          menuVisible && 'd-flex'
        )}
      >
        <div className='d-flex flex-column px-7 py-5 ' data-kt-user-table-filter='form'>
          {shareTreeLink ? (
            <ShareLink link={shareTreeLink!} copiedLabelId={'SIM.VIEW.ARTICLE_LINK_COPIED'}>
              <div className='menu-item'>
                <div className='menu-link'>
                  <span className='menu-icon'>
                    <ShareIcon src={toAbsoluteUrl('/media/icons/duotune/arrows/arr078.svg')} />
                  </span>
                  <span className='menu-title'>{intl.formatMessage({id: 'SHARE'})}</span>
                </div>
              </div>
            </ShareLink>
          ) : null}
          {!readonly && is_premium ? (
            <>
              <div className='menu-item' onClick={handleEditPress}>
                <div className='menu-link'>
                  <span className='menu-icon'>
                    <i className='ki-duotone ki-notepad-edit fs-2'>
                      <span className='path1' />
                      <span className='path2' />
                      <span className='path3' />
                      <span className='path4' />
                    </i>
                  </span>
                  <span className='menu-title'>{intl.formatMessage({id: 'EDIT'})}</span>
                </div>
              </div>
              {/* <div className='menu-item' onClick={()=>handlePublishArticle(!publish)}>
                <div className='menu-link'>
                  <span className='menu-icon'>
                    {publish ?
                      <i className="ki-duotone ki-eye-slash">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                        <span className="path4"></span>
                      </i>
                      :
                      <i className="ki-duotone ki-eye">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                      </i>
                    }

                  </span>
                  <span className='menu-title'>{intl.formatMessage({id: publish ? 'ARTICLE.SET.UNPUBLISH' : "ARTICLE.SET.PUBLISH"})}</span>
                </div>
              </div> */}
              <div className='menu-item' onClick={handleDeletePress}>
                <div className='menu-link'>
                  <span className='menu-icon'>
                    <i className='ki-duotone ki-trash fs-2'>
                      <span className='path1' />
                      <span className='path2' />
                      <span className='path3' />
                      <span className='path4' />
                    </i>
                  </span>
                  <span className='menu-title'>{intl.formatMessage({id: 'DELETE'})}</span>
                </div>
              </div>
              {!first && (
                <div className='menu-item' onClick={upArticle}>
                  <div className='menu-link'>
                    <span className='menu-icon'>
                      <i className='ki-duotone ki-up'></i>
                    </span>
                    <span className='menu-title'>{intl.formatMessage({id: 'UP'})}</span>
                  </div>
                </div>
              )}

              {!last && (
                <div className='menu-item' onClick={downArticle}>
                  <div className='menu-link'>
                    <span className='menu-icon'>
                      <i className='ki-duotone ki-down'></i>
                    </span>
                    <span className='menu-title'>{intl.formatMessage({id: 'DOWN'})}</span>
                  </div>
                </div>
              )}

              {(!first && articlesLength > 2) && (
                <div className='menu-item' onClick={moveToFirst}>
                  <div className='menu-link'>
                    <span className='menu-icon'>
                      <i className="ki-duotone ki-double-up">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                      </i>
                    </span>
                    <span className='menu-title'>{intl.formatMessage({id: 'TO_TOP_OF_LIST'})}</span>
                  </div>
                </div>
              )}

              {(!last && articlesLength > 2) && (
                <div className='menu-item' onClick={moveToLast}>
                  <div className='menu-link'>
                    <span className='menu-icon'>
                      <i className="ki-duotone ki-double-down">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                      </i>
                    </span>
                    <span className='menu-title'>{intl.formatMessage({id: 'TO_BOTTOM_OF_LIST'})}</span>
                  </div>
                </div>
              )}
            </>
          ) : null}
        </div>
      </MenuDropdown>
    </div>
  )
}

export default React.memo(SimArticleMenu)

const MenuDropdown = styled.div`
    right: 0;
`
